export default "__VITE_ASSET__BjrAP_Qg__"